module.exports = __webpack_public_path__ + "static/FBClientSecret-450d558be42d429c630d9e1dc3718216.png";